import { OrderItem } from '../../types/order';

interface TableOrderInfoProps {
  orderItems: OrderItem[]
}

export default function TableOrderInfo({ orderItems }: TableOrderInfoProps) {

  return (
    <div className="flex flex-col mt-3">
      <div className="-m-1.5 overflow-x-auto">
        <div className="p-1 min-w-full inline-block align-middle">
          <div className="overflow-hidden rounded">
              <table className="min-w-full">
                <thead className="w-full">
                  <tr>
                      {["Qty:", "Description:"].map((col, i) => (
                          <th key={i} scope="col" className={`px-2 py-1 text-[13px] md:text-sm font-medium whitespace-normal break-words text-left ${ col === "AMNT:" ? "text-right" : "text-left" }`}>
                              {col}
                          </th>
                      ))}
                  </tr>
                </thead>
                <tbody className="">
                  {orderItems?.map((item, i) => {
                      const productDescription = `${item.categoryName?.split(" ")[0]} | ${item.productName} (${item.size})`;
                      const addons = item.addons ?? [];
                      return (
                          <tr key={i} className="transition-colors duration-150">
                              <td className="px-2 py-0.5 align-top text-[13px]">{item.qty}</td>
                              <td className="px-2 py-0.5 text-[13px]">
                                  <span>{productDescription}</span>
                                  {addons.length > 0 && (
                                      <div className="mt-1 flex flex-col">
                                          {addons.map(add => (
                                              <div key={add.addonID} className="flex items-center gap-2 text-xs text-gray-500">
                                                  <span>•</span>
                                                  <span>{add.addonName}</span>
                                              </div>
                                          ))}
                                      </div>
                                  )}
                              </td>
                          </tr>
                      );
                  })}
                </tbody>
              </table>
            </div>
        </div>
      </div>
    </div>
  )
}
